// extracted by mini-css-extract-plugin
export default {"icon":"_ffc18294"};